import { isFunction, isNumber } from '../core'

type IClass = new (...args: any[]) => any
type IClassPrototype = IClass['prototype']

const DECORATOR_ERROR = '装饰的元素必须是个函数类型'
const callError = (pre: string) => `${pre}调用错误，请阅读相关使用文档`

const connect = (func: any, timeout?: any) => {
  // 标识当前是否用在装饰器环境下
  let isDecorator = false
  // 存储需要包装的放啊
  let _func!: Function
  // 存储定时时间
  let _timeout!: number

  // 验证是否在普通函数调用中
  if (isFunction(func) && isNumber(timeout)) {
    _func = func
    _timeout = timeout
  }
  // 装饰器中
  else if (isNumber(func) && timeout === undefined) {
    _timeout = func
    isDecorator = true
  }
  else {
    throw new Error(callError(throttle.name))
  }

  return { isDecorator, _func, _timeout }
}

/** 节流 */
function throttle(timeout: number): (prototype: IClassPrototype, propertyName: string, descriptor: PropertyDescriptor) => PropertyDescriptor
function throttle(func: Function, timeout: number): Function
function throttle(func: any, timeout?: any) {

  let { isDecorator, _func, _timeout } = connect(func, timeout)

  // 存储之前触发的时间
  let previous = 0
  // 当前时间
  let nowTime = 0

  const _throttle = function (this: any) {
    nowTime = Date.now()
    if (nowTime - previous > _timeout) {
      _func.apply(this, arguments)
      previous = nowTime
    }
  }

  if (isDecorator) {
    return function (_: IClassPrototype, __: string, descriptor: PropertyDescriptor) {
      // 获取旧函数
      _func = descriptor.value || descriptor['initializer']()
      if (!isFunction(_func)) throw new Error(DECORATOR_ERROR)
      return { value: _throttle } as PropertyDescriptor
    }
  } else {
    return _throttle
  }

}

/** 防抖 */
function debounce(timeout: number): (prototype: IClassPrototype, propertyName: string, descriptor: PropertyDescriptor) => PropertyDescriptor
function debounce(func: Function, timeout: number): Function
function debounce(func: any, timeout?: any) {

  let { isDecorator, _func, _timeout } = connect(func, timeout)

  // 存储定时器
  let timer: NodeJS.Timeout | undefined

  // const _debounce = function (this: any, reactEvent: any) {
  const _debounce = function (this: any) {
    const _arguments = arguments
    timer && clearTimeout(timer)
    // react17版本下此方法没有什么作用
    // reactEvent?.persist()
    timer = setTimeout(() => {
      _func.apply(this, _arguments)
      timer = undefined
    }, _timeout)
  }

  if (isDecorator) {
    return function (_: IClassPrototype, __: string, descriptor: PropertyDescriptor) {
      // 获取旧函数
      _func = descriptor.value || descriptor['initializer']()
      if (!isFunction(_func)) throw new Error(DECORATOR_ERROR)
      return { value: _debounce } as PropertyDescriptor
    }
  } else {
    return _debounce
  }

}

export default {
  throttle,
  debounce
}